import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ProductAttributeGroupRelationshipRow,
    WB_TagFunctionParamRow,
    WB_TagFunctionRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbTagFunction} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Product_Attribute_Group_Relationship,
    esWB_Tag_Function,
    esWB_Tag_Function_Param, esWB_Transaction_Item
} from "../PA.Core/PAdbSchema";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {TagBO} from "./TagBO";

export class TagFunctionBO implements IBusinessObject
{

    //<editor-fold desc = "Properties and Constructor">

    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_TagFunction: WB_TagFunctionRow

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Tag Function'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_TagFunction = null;
    }

    //</editor-fold>

    get WB_TagFunction(): WB_TagFunctionRow {
        return this.drWB_TagFunction;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Tag Function");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error)=>{

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Tag Function.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Tag_Function)
                .then((newTagFunctionRow: WB_TagFunctionRow) => {
                    newTagFunctionRow.setDefaults()
                    self.drWB_TagFunction = newTagFunctionRow;
                    self.dbContext.add(esWB_Tag_Function, newTagFunctionRow)
                    self.Identity.setAll(self.WB_TagFunction.cif.WB_TAG_FUNCTION_ID, self.WB_TagFunction.cif.TAG_FUNCTION_ID, self.WB_TagFunction.cif.TAG_FUNCTION_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_TagFunction, 'WB_TAG_FUNCTION_ID', 'TAG_FUNCTION_ID', 'TAG_FUNCTION_NAME')


                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        })

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>


        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Tag Function already loaded.";
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if(self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Tag Function."
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError);
                return;
            }

            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = TagFunctionBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = TagFunctionBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aTagFunctionRow: any = recordResolver.get(esWB_Tag_Function, anId)

                    if(_.isEmpty(aTagFunctionRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_TagFunction = aTagFunctionRow;
                    self.Identity.setAll(self.WB_TagFunction.cif.WB_TAG_FUNCTION_ID, self.WB_TagFunction.cif.TAG_FUNCTION_ID, self.WB_TagFunction.cif.TAG_FUNCTION_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_TagFunction, 'WB_TAG_FUNCTION_ID', 'TAG_FUNCTION_ID', 'TAG_FUNCTION_NAME')
                })
                .then((aTagFunctionRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_TagFunction.cif.TAG_FUNCTION_NAME + "(" + self.WB_TagFunction.cif.TAG_FUNCTION_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate Tag Function.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbTagFunction = <IwbTagFunction>self.drWB_TagFunction;
        this.SaveProgressProvider.start("Saving " + wbTagFunction.TAG_FUNCTION_NAME + "(" + wbTagFunction.TAG_FUNCTION_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Tag Function.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let tasks: Promise<any> [] = [];
            saveFunction(esWB_Tag_Function, self.drWB_TagFunction,{})
                .then((ignored) => {
                    tasks.push(saveFunction(esWB_Tag_Function_Param, self.drWB_TagFunction.WB_TagFunctionParamRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }


    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbTagFunction = <IwbTagFunction>self.drWB_TagFunction;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbTagFunction.TAG_FUNCTION_NAME + "(" + wbTagFunction.TAG_FUNCTION_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_TagFunction.markDeleted()

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    addTagFunctionParam(): Promise<IBusinessObject> {
        const self = this;
        return new Promise<IBusinessObject>((resolve, reject)=> {

            self.dbContext.createRecordWithKey(esWB_Tag_Function_Param)
                .then((aTagFunctionParamRow: WB_TagFunctionParamRow)=>{
                    aTagFunctionParamRow.setDefaults();
                    aTagFunctionParamRow.cif.WB_TAG_FUNCTION_ID = self.drWB_TagFunction.cif.WB_TAG_FUNCTION_ID;
                    aTagFunctionParamRow.WB_TagFunctionRow = self.drWB_TagFunction;
                    self.dbContext.add(esWB_Tag_Function_Param, aTagFunctionParamRow);
                    resolve(self)
                })
                .catch((err)=>{
                    reject(err)
                })
        })

    }

    removeTagFunctionParam(aWB_TagFunctionParam_ID: number): Promise<IBusinessObject>{
        const self = this;

        return new Promise<IBusinessObject>((resolve, reject)=>{
            _.forEach(self.drWB_TagFunction.WB_TagFunctionParamRows, (aTagFunctionParam: WB_TagFunctionParamRow)=>{
                if(aTagFunctionParam.isActive && aTagFunctionParam.cif.WB_TAG_FUNCTION_PARAM_ID == aWB_TagFunctionParam_ID){
                    aTagFunctionParam.markDeleted();
                }
            });
            resolve(self)
        })
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const tag_function_options: CreateOptions = {
            standardConditions: {
            },
            dctIncludeBelongsToNamedRelations: {
            }
        }

        return new ESRecordResolver(dbContext, tag_function_options);

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Tag_Function,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass( TagFunctionBO, "TagFunctionBO" ,"Tag Function")
